import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-10 md:py-20 px-4 bg-cream" data-id="element-62">
      <div className="max-w-3xl mx-auto" data-id="element-63">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-white p-5 md:p-12 rounded-2xl shadow-xl border-4 border-gold/30 text-center relative" data-id="element-64">
          <div className="absolute -top-10 left-1/2 transform -translate-x-1/2 bg-teal-dark p-4 rounded-full shadow-lg border-4 border-white" data-id="element-65">
            <ShieldCheck className="w-10 h-10 text-gold-light" data-id="element-66" />
          </div>

          <h2 className="text-2xl md:text-3xl font-bold font-heading text-teal-dark mt-6 mb-6" data-id="element-67">
            Garantía de Paz de 7 Días
          </h2>

          <p className="text-lg text-charcoal/80 leading-relaxed mb-6" data-id="element-68">
            Prueba el protocolo por una semana completa. Si no sientes que tu
            conexión con Dios ha mejorado y que tu ansiedad ha disminuido,
            devuélvelo.
          </p>

          <p className="text-lg text-charcoal/80 leading-relaxed font-medium" data-id="element-69">
            Te reintegramos el 100% de tu dinero sin preguntas.
          </p>

          <div className="mt-8 inline-block bg-cream px-6 py-3 rounded-full border border-gold/50" data-id="element-70">
            <p className="font-bold text-teal-dark text-lg" data-id="element-71">
              El riesgo es nuestro, la bendición es tuya.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}